export interface IUser {
  usuario: {
    id: number;
    idCliente: number;
    idLoja: number;
    nome: string;
    login: string;
    senha: string;
    ultimaSenha: string | null;
    contato: string | null;
    email: string | null;
    contatoAlerta: string | null;
    emailAlerta: string | null;
    nivel: number;
    dataCadastro: string;
    dataAlteracao: string | null;
    dataExclusao: string | null;
    chave: string | null;
    logoIkone: string;
    chave2fa: string | null;
    ativacao: number;
    reset: number;
    ativo: number;
    idRegional: number;
    idsRegionaisVinculadas: number[];
    idsRegional: number[];
    idsLoja: number[];
    logos?: any[];
    loja: {
      id: number;
      idDivisao?: number;
      idRegional: number;
      idCoordenacao: number;
      idSeguradora?: number;
      numero: string | null;
      nome: string | null;
      importanciaSegurada: number;
      endereco: string | null;
      uf: string | null;
      arquivoPlanta: string | null;
      ativo: number;
      latitude?: number | null;
      longitude?: number | null;
      cnpj?: string | null;
      vigencia?: string | null;
    };
  };
  customCliente: {
    id: number;
    nomeEmpresarial: string;
    nomeFantasia: string;
    descricao: string;
    imgLogotipo: string;
    imgBack: string;
    imgFaixa: string;
    primaryDarkColor: string;
    primaryColor: string;
    primaryLightColor: string;
    secondaryColor: string;
    textDarkColor: string;
    textLightColor: string;
    successColor: string;
    dangerColor: string;
    warningColor: string;
    infoColor: string;
    dataEvento: string;
    dataUltimaAlteracao: string;
    ativo: number;
  };
  acesso: {
    divisao: boolean;
    regional: boolean;
    loja: boolean;
    menuMapa: boolean;
    menuDashboard: boolean;
    menuRelatorios: boolean;
    menuDocAVCB: boolean;
    menuConfigLoja: boolean;
    menuConfigUsuarios: boolean;
    menuConfigGruposMonitor: boolean;
    menuConfigCustom: boolean;
  };
  token: string;
  message: string;
}

const KEY_SESSION_USER = "SESSION_USER";

const setUser = (user: any) =>
  new Promise((resolve: any, reject: any) => {
    if (user.token) {
      sessionStorage.setItem(KEY_SESSION_USER, JSON.stringify(user));
      resolve();
    } else {
      reject();
    }
  });

const logout = () => {
  sessionStorage.removeItem(KEY_SESSION_USER);
  window.location.href = "/";
};

const getUser = () => {
  const user: IUser = JSON.parse(`${sessionStorage.getItem(KEY_SESSION_USER)}`);
  return user;
};

export { setUser, getUser, logout };
